/* eslint-disable */
import { CommonGet, CommonPost } from '../../../helpers/HttpClient';
import TokenDecoder from 'src/helpers/TokenDecoder';

export default {
    GetAllGroupsForDropDown,
    GetAllFactoriesByGroupID,
    GetVCCOrderDetails,
    GetSupplierDetailsForOrder,
    GetSupplierCropVarityQuntityDetails,
    ApproveOrder,
    AddSuppliers,
    RemoveSuppliers,
    EditSuppliers,
    ReturnOrder,
    ApproveReadyToWeighment,
    GetVCCOrderBreakdownDetailsByPerformOrderID
};

async function GetAllGroupsForDropDown() {
    const response = await CommonGet('/api/Group/GetAllGroups', null);
    return response.data;
}

async function GetAllFactoriesByGroupID(groupID) {
    const response = await CommonGet('/api/Factory/GetAllFactoriesByGroupID', 'groupID=' + parseInt(groupID));
    return response.data;
}

async function GetVCCOrderDetails(operationEntityID, date) {
    const response = await CommonGet('/api/Supplier/GetVCCOrderDetails', 'operationEntityID=' + parseInt(operationEntityID) + '&date=' + date);
    return response.data;
}

async function GetSupplierDetailsForOrder(operationEntityID, cropID, date) {
    const response = await CommonGet('/api/Supplier/GetSupplierDetailsForOrder', 'operationEntityID=' + parseInt(operationEntityID) + '&cropID=' + parseInt(cropID) + '&date=' + date);
    return response.data;
}

async function GetSupplierCropVarityQuntityDetails(farmerID, cropID, date) {
    const response = await CommonGet('/api/Supplier/GetSupplierCropVarityQuntityDetails', 'farmerID=' + parseInt(farmerID) + '&cropID=' + parseInt(cropID) + '&date=' + date);
    return response.data;
}

async function GetVCCOrderBreakdownDetailsByPerformOrderID(performOrderID) {
    const response = await CommonGet('/api/Supplier/GetVCCOrderBreakdownDetailsByPerformOrderID', 'performOrderID=' + parseInt(performOrderID));
    return response.data;
}

async function ApproveOrder(data) {
    var values = {
        performOrderID: parseInt(data.performOrderID),
        quantity: parseFloat(data.quantity),
        productCode: data.productCode,
        orderDate: data.orderDate,
        modifiedBy: parseInt(TokenDecoder.getUserIDFromToken()),
    }
    const response = await CommonPost('/api/Supplier/ApproveOrder', null, values);
    return response;
}

async function AddSuppliers(supplierOrderDeails, supplierData) {

    var values = {
        performOrderID: parseInt(supplierOrderDeails.performOrderID),
        cropForecastDetailID: parseInt(supplierData.cropForecastDetailID),
        operationEntityID: parseInt(supplierOrderDeails.operationEntityID),
        farmerID: parseInt(supplierData.farmerID),
        cropID: parseInt(supplierOrderDeails.cropID),
        cropVarietyID: parseInt(supplierData.cropVarityID),
        dueDate: supplierOrderDeails.orderDate,
        productCode: supplierOrderDeails.productCode,
        acceptedQuantity: parseFloat(supplierData.quantity),
        availbaleQuantity: parseFloat(supplierData.availbaleQty),
        remainingQuantity: parseFloat(supplierData.reaminCount),
        createdBy: parseInt(TokenDecoder.getUserIDFromToken())
    }
    const response = await CommonPost('/api/Supplier/AddSupplier', null, values);
    return response;
}

async function RemoveSuppliers(supplierData, supplierOrderDeails) {
    var values = {
        performOrderFarmerMappingID: parseInt(supplierData.performOrderFarmerMappingID),
        performOrderID: parseInt(supplierOrderDeails.performOrderID),
        cropForecastDetailID: parseInt(supplierData.cropForecastDetailID),
        operationEntityID: parseInt(supplierOrderDeails.operationEntityID),
        cropID: parseInt(supplierOrderDeails.cropID),
        acceptedQuantity: parseFloat(supplierData.acceptedQuantity),
        dueDate: supplierOrderDeails.orderDate,
        productCode: supplierOrderDeails.productCode,
        createdBy: parseInt(TokenDecoder.getUserIDFromToken())
    }
    const response = await CommonPost('/api/Supplier/RemoveSupplier', null, values);
    return response;
}

async function EditSuppliers(supplierData, supplierOrderUpdateDeails, supplierOrderDeails, found) {
    var values = {
        performOrderFarmerMappingID: parseInt(supplierOrderUpdateDeails.performOrderFarmerMappingID),
        performOrderID: parseInt(supplierData.performOrderID),
        cropForecastDetailID: parseInt(supplierOrderDeails.cropForecastDetailID),
        acceptedQuantity: parseFloat(supplierOrderDeails.quantity),
        acceptedOldQuantity: parseFloat(parseFloat(supplierOrderUpdateDeails.acceptedQuantity) - parseFloat(supplierOrderDeails.quantity)),
        existsQuantity: parseFloat(found.quantity) + parseFloat(supplierOrderDeails.availbaleQty),
        existsAcceptedQuantity: ((parseFloat(supplierData.acceptedQuantity) - parseFloat(supplierOrderUpdateDeails.acceptedQuantity)) + parseFloat(supplierOrderDeails.quantity)),
        dueDate: supplierData.orderDate,
        productCode: supplierData.productCode,
        operationEntityID: parseInt(supplierData.operationEntityID),
        cropID: parseInt(supplierData.cropID),
        createdBy: parseInt(TokenDecoder.getUserIDFromToken())
    }
    const response = await CommonPost('/api/Supplier/EditSupplier', null, values);
    return response;
}

async function ReturnOrder(returnOrderData, supplierOrderUpdateDeails) {
    var values = {
        performOrderID: parseInt(supplierOrderUpdateDeails.performOrderID),
        operationEntityID: parseInt(supplierOrderUpdateDeails.operationEntityID),
        operationEntityCode: supplierOrderUpdateDeails.operationEntityCode,
        factoryName: supplierOrderUpdateDeails.factoryName,
        cropID: parseInt(supplierOrderUpdateDeails.cropID),
        productCode: supplierOrderUpdateDeails.productCode,
        productName: supplierOrderUpdateDeails.productName,
        returnQuantity: parseFloat(supplierOrderUpdateDeails.reaminingQuantity),
        orderDate: supplierOrderUpdateDeails.orderDate,
        realizedPrice: parseFloat(supplierOrderUpdateDeails.realizedPrice),
        reason: returnOrderData.reason,
        createdBy: parseInt(TokenDecoder.getUserIDFromToken())
    }
    const response = await CommonPost('/api/Supplier/ReturnOrder', null, values);
    return response;
}

async function ApproveReadyToWeighment(data) {
    var values = {
        performOrderFarmerMappingID: parseInt(data.performOrderFarmerMappingID),
        modifiedBy: parseInt(TokenDecoder.getUserIDFromToken()),
    }
    const response = await CommonPost('/api/Supplier/ApproveReadyToWeighment', null, values);
    return response;
}